export default __webpack_public_path__ + "static/summer_containers25-664668d9b4ba2d98adc1114bab5a90e2.webp";